var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"home",attrs:{"fill-height":"","fill-width":""}})}
var staticRenderFns = []

export { render, staticRenderFns }